import { MarkerOdComponent } from "./marker-od/marker-od.component";
import { MarkerStopDisabledComponent } from "./marker-stop-disabled/marker-stop-disabled.component";
import { MarkerStopComponent } from "./marker-stop/marker-stop.component";

export {
  MarkerOdComponent,
  MarkerStopComponent,
  MarkerStopDisabledComponent,
};

export const markers = [
  MarkerOdComponent,
  MarkerStopComponent,
  MarkerStopDisabledComponent,
]
